import z from "zod";
import { storedErrorReportSchema, storedErrorSchema } from "../errors";
import { timestampsSchema } from "../helpers";
import { ModelOutputTypeEnum, ModelQuantizationEnum, modelOutputSchema, } from "./model.schema";
export var ModelConversionStatusEnum;
(function (ModelConversionStatusEnum) {
    ModelConversionStatusEnum["PENDING"] = "PENDING";
    ModelConversionStatusEnum["RUNNING"] = "RUNNING";
    ModelConversionStatusEnum["DONE"] = "DONE";
    ModelConversionStatusEnum["FAILED"] = "FAILED";
    ModelConversionStatusEnum["CANCELLED"] = "CANCELLED";
})(ModelConversionStatusEnum || (ModelConversionStatusEnum = {}));
export const isTerminalConversionStatus = (status) => status === ModelConversionStatusEnum.DONE ||
    status === ModelConversionStatusEnum.FAILED ||
    status === ModelConversionStatusEnum.CANCELLED;
export var Rvc4QuantizationModeEnum;
(function (Rvc4QuantizationModeEnum) {
    Rvc4QuantizationModeEnum["FP16_STANDARD"] = "FP16_STANDARD";
    Rvc4QuantizationModeEnum["INT8_STANDARD"] = "INT8_STANDARD";
    Rvc4QuantizationModeEnum["INT8_ACCURACY_FOCUSED"] = "INT8_ACCURACY_FOCUSED";
    Rvc4QuantizationModeEnum["INT8_INT16_MIXED"] = "INT8_INT16_MIXED";
    Rvc4QuantizationModeEnum["INT8_INT16_MIXED_ACCURACY_FOCUSED"] = "INT8_INT16_MIXED_ACCURACY_FOCUSED";
})(Rvc4QuantizationModeEnum || (Rvc4QuantizationModeEnum = {}));
export const INT8_QUANTIZATION_MODES = [
    Rvc4QuantizationModeEnum.INT8_STANDARD,
    Rvc4QuantizationModeEnum.INT8_ACCURACY_FOCUSED,
    Rvc4QuantizationModeEnum.INT8_INT16_MIXED,
    Rvc4QuantizationModeEnum.INT8_INT16_MIXED_ACCURACY_FOCUSED,
];
export const isInt8QuantizationMode = (mode) => INT8_QUANTIZATION_MODES.includes(mode);
export const defaultQuantizationMode = (precision) => precision === ModelQuantizationEnum.INT8
    ? Rvc4QuantizationModeEnum.INT8_INT16_MIXED
    : Rvc4QuantizationModeEnum.FP16_STANDARD;
export const CONVERSION_TARGETS = [
    ModelOutputTypeEnum.RVC2,
    ModelOutputTypeEnum.RVC3,
    ModelOutputTypeEnum.RVC4,
];
export const conversionTargetSchema = z.enum(CONVERSION_TARGETS);
export const isConversionTarget = (type) => CONVERSION_TARGETS.includes(type);
export const MAX_CALIBRATION_IMAGES = 400;
export const conversionSettingsSchema = z.object({
    quantizationMode: z.enum(Rvc4QuantizationModeEnum).optional(),
    calibrationMaxImages: z
        .number()
        .int()
        .min(1)
        .max(MAX_CALIBRATION_IMAGES)
        .default(MAX_CALIBRATION_IMAGES),
    overrides: z.record(z.string(), z.unknown()).default({}),
});
export const modelConversionSchema = z.object({
    id: z.number(),
    modelId: z.number(),
    target: conversionTargetSchema,
    precision: z.enum(ModelQuantizationEnum),
    settings: conversionSettingsSchema,
    status: z.enum(ModelConversionStatusEnum),
    attemptCount: z.number(),
    hasLog: z.boolean(),
    ...storedErrorSchema.shape,
    startedAt: z.iso.datetime().nullable(),
    finishedAt: z.iso.datetime().nullable(),
    output: modelOutputSchema.nullable(),
    ...timestampsSchema,
});
export const createModelConversionSchema = z
    .object({
    target: conversionTargetSchema,
    precision: z
        .enum(ModelQuantizationEnum)
        .default(ModelQuantizationEnum.FP16),
    settings: conversionSettingsSchema.default({
        calibrationMaxImages: MAX_CALIBRATION_IMAGES,
        overrides: {},
    }),
})
    .refine((data) => data.target === ModelOutputTypeEnum.RVC4 ||
    data.settings.quantizationMode === undefined, { message: "quantizationMode applies to RVC4 conversions only" })
    .refine((data) => data.settings.quantizationMode === undefined ||
    isInt8QuantizationMode(data.settings.quantizationMode) ===
        (data.precision === ModelQuantizationEnum.INT8), { message: "quantizationMode does not match the requested precision" });
export const conversionProgressRequestSchema = z.object({
    message: z.string(),
});
export const conversionCompleteRequestSchema = z.object({
    objectPath: z.string(),
    metadata: z.record(z.string(), z.unknown()).default({}),
});
export const conversionErrorRequestSchema = storedErrorReportSchema;
export const conversionLogChunkSchema = z.object({
    offset: z.number(),
    content: z.string(),
    complete: z.boolean(),
});
//# sourceMappingURL=conversion.schema.js.map